import React, { useRef } from 'react'

import { ModalButtons } from '@cvg/react-components'

const { ContentModalButton } = ModalButtons

import Media from '../Media'
import Content from '../Content'
import EntryModal from '../EntryModal'
import Tags from '../Tags'

import styles from './styles.module.css'

const EntryCard = ({ entry }) => {
  const videoRef = useRef(null)

  return (
    <li className={styles.entry}>
      <ContentModalButton
        content={<EntryModal entry={entry} />}
        title='Media Preview'
        onOpen={() => videoRef.current?.pause()}
      >
        <Media media={entry.media} isModal={false} playsInline preload='metadata' videoRef={videoRef} />
        <Content entry={entry} />
        <Tags entry={entry} />
      </ContentModalButton>
    </li>
  )
}

export default EntryCard
